<template>
  <div class = "ml-3 mt-3">
    <h5>Hi {{ userName }} choose from the menu above</h5>
    <b-img :src = "urlPrefix + '/static/img/LogoTightCrop.gif'"  width = "300" fluid-grow alt="whoops its not there !"></b-img>
  </div>
</template>

<script>
export default {
  computed:{
    urlPrefix(){
      return this.$store.getters.urlPrefix
    }
    
  },
    mounted(){
        this.userName = localStorage.getItem("userName")
    },
  data() {
    return {
      userName: "",
    };
  },
};
</script>

<style scoped></style>
